// serve -p 8080 ~/code/Limitless_2.0.1/Bootstrap\ 4/Template/
// http://127.0.0.1:8080/layout_1/LTR/material/full/index.html
import React, { Component } from "react";
import { withStyles } from "@mui/styles";
import Typography from "@mui/material/Typography";
import USER_ROLES from "../common/userroles";
import Console from "../console";
import { withTranslation } from "react-i18next";

const styles = (theme) => ({
  iframeContainer: {},
  iframe: {
    width: "100%",
    height: "calc(100vh - 150px)",
    border: 0,
  },
  typography: {
    color: "rgba(0, 0, 0, 0.54)",
    fontSize: "2.125rem",
    fontWeight: 400,
    lineHeight: "1.20588em",
    marginLeft: "1rem",
  },
  title: {
    marginTop: "15px",
  },
});

class Dashboard2 extends Component {
  render() {
    const { classes, t } = this.props;
    return (
      <div>
        {JSON.parse(sessionStorage.getItem("permissionUser")) &&
        JSON.parse(sessionStorage.getItem("permissionUser")) ===
          USER_ROLES.DELIVERYTECH ? (
          <Console />
        ) : (
          <div className={classes.title}>
            <Typography
              variant="display1"
              gutterBottom
              className={classes.typography}
            >
              {t("Leftbar.Dashboard")}
            </Typography>
            <div className={classes.iframeContainer}>
              <iframe
                className={classes.iframe}
                allowtransparency="true"
                title={t("Leftbar.Dashboard")}
                src={
                  "/static/dashboard/layout_1/LTR/material/full/index.html#" +
                  process.env.REACT_APP_BASEURL
                }
              />
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default withStyles(styles)(withTranslation()(Dashboard2));



// WEBPACK FOOTER //
// ./src/components/dashboard2/index.js